import { css } from 'styled-components';
import COLORS from './colors';
import BREAKPOINTS from './breakpoints';
import TYPOGRAPHY from './typography';
import globalStyles from './global';

export { COLORS, BREAKPOINTS, TYPOGRAPHY, globalStyles };

export const scrollBarStyling = css`
  /* width */
  ::-webkit-scrollbar {
    width: 4px;
    cursor: pointer;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${COLORS.white};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${COLORS.neutral_200};
    border-radius: 8px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${COLORS.neutral_400};
  }
`;
